import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useDowntimeEditModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.showDowntimeModalState, ...args };
    updateGlobalState({ showDowntimeModalState: newState });
  };

  return {
    block: state.showDowntimeModalState.block,
    close: () => {
      setState({ block: null, isOpen: false });
    },
    isOpen: state.showDowntimeModalState.isOpen,
    open: (block) => {
      setState({ block, isOpen: true });
    },
  };
}
